export const facebook = {
	icon:
		'm34.1 47v-13.7h4.6l0.7-5.3h-5.3v-3.4c0-1.5 0.4-2.6 2.6-2.6h2.8v-4.8c-0.5-0.1-2.2-0.2-4.1-0.2-4.1 0-6.9 2.5-6.9 7v4h-4.5v5.3h4.6v13.7h5.5z',
	mask:
		'M0,0v64h64V0H0z M39.6,22l-2.8,0c-2.2,0-2.6,1.1-2.6,2.6V28h5.3l-0.7,5.3h-4.6V47h-5.5V33.3H24V28h4.6V24 c0-4.6,2.8-7,6.9-7c2,0,3.6,0.1,4.1,0.2V22z',
	color: '#3b5998',
};
